import { createFileRoute } from '@tanstack/react-router'

import { BlytzCollectFunnelScreen } from '../../components/blytz-collect-funnel-screen.tsx'

export const Route = createFileRoute('/blytzcollect/funnel')({
  component: BlytzCollectFunnelScreen
})
